export type ReportChecklistItem = { label: string; completed: boolean };

export function normalizeReportChecklist(value: unknown): ReportChecklistItem[] {
  if (!Array.isArray(value)) return [];
  const items = new Map<string, ReportChecklistItem>();
  for (const item of value) {
    const rawLabel = typeof item === 'string' ? item : item?.label || item?.name;
    if (typeof rawLabel !== 'string' || !rawLabel.trim()) continue;
    const label = rawLabel.trim();
    // String entries are the mobile/API format for completed tasks.
    const completed = typeof item === 'string' || item.completed === true;
    const previous = items.get(label);
    items.set(label, { label, completed: completed || previous?.completed === true });
  }
  return Array.from(items.values());
}
